import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  CardContent,
  Box,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert
} from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { assignmentService } from '../../services/api';

const SectionBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noBorder',
})(({ theme, noBorder }) => ({
  padding: theme.spacing(2),
  borderBottom: noBorder ? 'none' : '1px solid #ccc',
}));

const StudentGrade = () => {
  const { assignment_id, learner_id, course_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [assignment, setAssignment] = useState(null);
  const [testDetails, setTestDetails] = useState(null);
  const [students, setStudents] = useState([]);
  const [student, setStudent] = useState(null);
  const [course, setCourse] = useState(null);
  const [grade, setGrade] = useState('');
  const [comment, setComment] = useState('');
  const [refererflag, setRefererFlag] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [Warning, setWarning] = useState();

  useEffect(() => {
    const fetchGradeData = async () => {
      try {
        setLoading(true);
        const response = await assignmentService.getStudentGrade(assignment_id, learner_id, course_id);
        const data = response.data;
        setAssignment(data.assignment);
        setTestDetails(data.testDetails);
        setStudents(data.students);
        setCourse(data.course);
        const selectedStudent = data.students?.find(s => s.user_id === parseInt(learner_id));
        setStudent(selectedStudent);
        setGrade(data.testDetails?.marks || '');
        setComment(data.testDetails?.teacher_comment || '');
      } catch (err) {
        console.error('Failed to fetch grade data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchGradeData();
  }, [assignment_id, learner_id, course_id]);

  const handleUpdate = async () => {
    try {
      const response = await assignmentService.updateStudentGrade({
        marks: grade,
        teacher_comment: comment,
        user_id: learner_id,
        assignment_id,
        course_id,
        submission_id: testDetails.submission_id,
      });

      if (response.status === 200) {
        setSnackbarMessage('Grade updated successfully!');
        setSnackbarSeverity('success');
      } else {
        setSnackbarMessage('Failed to update grade.');
        setSnackbarSeverity('error');
      }
    } catch (error) {
      console.error('Error updating grade:', error);
      setSnackbarMessage('An error occurred while updating the grade.');
      setSnackbarSeverity('error');
    } finally {
      setOpenSnackbar(true);
    }
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  if (loading || !assignment || !testDetails || !student) {
    return <Typography>Loading...</Typography>;
  }
  const handleGradeChange = (e) => {
    const value = Number(e.target.value);
    if (value < 0) {
      setGrade(0);
      setWarning('Grade cannot be negative');
    } else if (value > 100) {
      setGrade(100);
      setWarning('Grade cannot be more than 100');
    } else {
      setGrade(value);
      setWarning('');
    }
  };

  return (
    <Container disableGutters maxWidth={false} sx={{ px: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 10, px: 2, py: 2 }}>
        <Typography variant="h5">{`Course: ${course.name}`}</Typography>
        <Typography variant="h5" color="textSecondary">{`Assignment: ${assignment.name}`}</Typography>
      </Box>


      {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#f1f5f9',
            p: 2,
            borderRadius: 2,
            mb: 2,
          }}
        > */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#3b5998' }}>
              Learner Name
            </Typography>
            <TextField
              select
              value={student?.user_id || ''}
              SelectProps={{ native: true }}
              size="small"
              sx={{ minWidth: 250 }}
              onChange={(e) =>
                setStudent(students.find((s) => s.user_id === parseInt(e.target.value)))
              }
              disabled={refererflag}
            >
              {students?.map(
                (student) =>
                  student.user_id === student.submitted_by && (
                    <option key={student.user_id} value={student.user_id}>
                      {student.first_name} {student.last_name}
                    </option>
                  )
              )}
            </TextField>
          </Box> */}
      {/* </Box> */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 3 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#d81b60',
            borderRadius: '50px',
            px: 4,
            '&:hover': {
              backgroundColor: '#c2185b',
            },
          }}
          onClick={handleUpdate}
        >
          Update
        </Button>

      </Box>

      <Grid container spacing={2}>
        {/* Left Section */}
        <Grid item xs={12} md={7}>
          <SectionBox>
            <Typography variant="h6">Summary</Typography>
            <Typography>
              <strong>Submitted:</strong>{' '}
              {moment(testDetails.created_at).utc().format('ddd MMM DD YYYY HH:mm:ss')} (UTC)
            </Typography>
            <Typography>
              <strong>File Types:</strong> System Files (Doc, PDF)
            </Typography>
          </SectionBox>
          <SectionBox noBorder>
            <Typography variant="h6" gutterBottom>
              Grade
            </Typography>
            <Box display="flex" alignItems="center">
              <TextField
                type="number"
                value={grade}
                onChange={handleGradeChange}
                size="small"
                sx={{ width: 100, mr: 1 }}
                inputProps={{ min: 0 }}
              />
              / 100
              {Warning && (
                <Typography color="error" variant="body2" sx={{ mt: 1, ml: 1 }}>
                  {Warning}
                </Typography>
              )}
            </Box>
          </SectionBox>
          <Box mt={2}>
            <Typography variant="subtitle1" color="primary" fontWeight="bold" sx={{ ml: 2 }}>
              Final Score: {grade} out of {assignment.points} / 100
            </Typography>
            <SectionBox noBorder>
              <Typography variant="h6">Comments:</Typography>
              <TextField
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                placeholder="Write comments here..."
              />
            </SectionBox>
          </Box>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={5}>
          <SectionBox noBorder>
            <Typography variant="h6">Attachments</Typography>
            {testDetails.attachement ? (
              <iframe
                src={`http://localhost:3000/uploads/assignment_submission/${testDetails.attachement}`}
                width="426"
                height="240"
                frameBorder="0"
                allowFullScreen
                title="attachment"
              ></iframe>
            ) : (
              <Typography color="error">No attachment</Typography>
            )}
          </SectionBox>
        </Grid>
      </Grid>

      {/* Snackbar for success/error messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default StudentGrade;
